export class Solicpescador{

  constructor(
    public nombre: string,
    public email: string,
    public telefono: string,
    public idusuario?: string,
    public _id?: string,
    public numerotickepago?: string,
    public procesado?: boolean,
    public prioridad?: number,
    public nombrearchivo?: string,
    public numeroperacion?: string,
    public seleccionado?: string,
    public nombrearchivopdf?: string,
    public solicitudhtml?: string,
    public enviadoporemail?: boolean,
    public numeroconfirmacion?: string,
    public procesarSolicitud?: boolean,
    public cantidad?: number,
    public costolicencia?: number,
    public idempresa?: string,
    public idinventarios?: string,
    public decompra?: boolean,
    public decompralicencia?: boolean,
    public vienedemodulo?: string,
    public usermx?: string,
    public cveusermx?: string,
    public emailbarco?: string





  ) {}

}
